import React, { useState, useEffect } from 'react';
import { Dialog, SimpleDialog, T } from '@colonist/ui';
import { getNestedTranslation, passThroughTranslation } from '@colonist/i18n';
import { EditProfileHeader } from './Parts/EditProfileHeader/EditProfileHeader.tsx';
import { EditProfileColorSelector } from './Parts/EditProfileColorSelector/EditProfileColorSelector.tsx';
/** Dialog to change a bot's color. */ export const BotEditProfileDialog = ({ open, onClose, username, icon, colors, selectedColor, onColorSelect, shouldHideStoreActions, onGoToStoreColors })=>{
    const [storePromptColor, setStorePromptColor] = useState(undefined);
    useEffect(()=>{
        setStorePromptColor(undefined);
    }, [
        open
    ]);
    var _storePromptColor_name;
    const storePromptColorName = (_storePromptColor_name = storePromptColor === null || storePromptColor === void 0 ? void 0 : storePromptColor.name) !== null && _storePromptColor_name !== void 0 ? _storePromptColor_name : passThroughTranslation('');
    const storePromptBody = (storePromptColor === null || storePromptColor === void 0 ? void 0 : storePromptColor.freeAtStore) ? getNestedTranslation({
        key: 'strings:homePage.header.defaultColorSelector.getColorForFree'
    }, {
        color: storePromptColorName
    }) : getNestedTranslation({
        key: 'strings:homePage.header.storePurchaseColorPrompt'
    }, {
        color: storePromptColorName
    });
    const visibleColors = shouldHideStoreActions ? colors.filter((colorOption)=>!colorOption.disabled) : colors;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        size: "sm"
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.popups.changeColor.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement(EditProfileHeader, {
        username: username,
        icon: icon,
        onEditClick: undefined
    }), /*#__PURE__*/ React.createElement(EditProfileColorSelector, {
        colors: visibleColors,
        selectedColor: selectedColor,
        onColorSelect: onColorSelect,
        onDisabledColorSelect: (colorId)=>{
            if (shouldHideStoreActions) return;
            const color = colors.find((colorOption)=>colorOption.colorId == colorId);
            if (color == undefined) return;
            setStorePromptColor({
                name: color.name,
                freeAtStore: color.freeAtStore
            });
        }
    })), !shouldHideStoreActions && /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: onGoToStoreColors
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.header.defaultColorSelector.getMoreColors'
        }
    })))), /*#__PURE__*/ React.createElement(SimpleDialog, {
        open: !shouldHideStoreActions && storePromptColor != undefined,
        onClose: ()=>setStorePromptColor(undefined),
        title: {
            key: 'strings:homePage.header.defaultColorSelector.youDoNotOwnThisColor'
        },
        body: storePromptBody,
        onConfirm: onGoToStoreColors,
        showCancelBtn: true
    }));
};
